import React from "react";

import store from "app/store";
import { Modal, Form, FormMessage, Button } from "lib/components/index";
import * as FormControl from "lib/components/FormControl";
import st from "lib/utils/index";
import { OrdersRepository } from "lib/repositories/index";
import { OrderDecorator } from "lib/decorators";

class ChangeOrderStatusPrompt extends React.PureComponent {
  constructor(...args) {
    super(...args);
    const { order } = this.props;
    this.state = {
      newStatus: order.status,
      submitLoading: false,
      error: null,
      notifySupplier: false,
    };
    this.subscriptions = [];
  }

  componentWillUnmount() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.subscriptions.length = 0;
  }

  handleSubmit({ notifyCustomer = true, notifySupplier = this.state.notifySupplier } = {}, sendOpinion) {
    const { order, resolve, redeliverCustomerOrderOpinionReminderEmail } = this.props;

    const { newStatus, submitLoading } = this.state;
    if (submitLoading) {
      return;
    }

    this.setState({ submitLoading: true, error: null });

    const changeStatus$ = OrdersRepository.changeStatus(order.id, order.token, newStatus, {
      notifyCustomer,
      notifySupplier,
    }).subscribe(
      (order) => {
        this.setState({ submitLoading: false });
        if (sendOpinion && order.status === "finished") {
          redeliverCustomerOrderOpinionReminderEmail(order);
        }
        resolve(order);
      },
      (error) => {
        st.api.handleError(error, store);
        this.setState({ submitLoading: false, error: st.api.findResponseErrorMessage(error) });
      }
    );
    this.subscriptions.push(changeStatus$);
  }

  render() {
    const { modalRef, resolve, order, ...props } = this.props;
    const { newStatus, submitLoading, error, notifySupplier } = this.state;
    const canNotifySupplier = st.authorize("notify_supplier", order);
    const statusOptions = [
      "building",
      "waiting_for_company_approval",
      "waiting_for_customer_approval",
      ...(st.authorize("set_any_status", order) || !order.requires_company_approval ? ["approved"] : []),
      ...(st.authorize("set_any_status", order) ? ["finished"] : []),
      ...["cancelled", "abandoned", "rejected"],
    ].map((status) => [status, I18n.humanAttributeName("order", status)]);
    return (
      <Modal closeIcon closeOnDimmerClick={false} size="small" ref={modalRef} {...props}>
        <Modal.Header>{I18n.t("papp.orders.ChangeOrderStatusPrompt.title")}</Modal.Header>
        <Modal.Content>
          <Form loading={submitLoading} error={!!error}>
            <FormMessage error={error} />

            <FormControl.SelectFormGroup
              value={newStatus}
              onChange={(newStatus) =>
                this.setState({
                  newStatus,
                  notifySupplier: newStatus === "waiting_for_company_approval" ? canNotifySupplier : notifySupplier,
                })
              }
              label={I18n.t("papp.orders.ChangeOrderStatusPrompt.choose_new_status")}
              required
              autoFocus
              options={statusOptions}
            />

            {canNotifySupplier && (
              <FormControl.CheckboxFormGroup
                checked={notifySupplier}
                onChange={(notifySupplier) => this.setState({ notifySupplier })}
                label={I18n.t("papp.orders.ChangeOrderStatusPrompt.notify_supplier")}
                toggle
              />
            )}

            <button type="submit" hidden disabled={submitLoading} />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button as="a" disabled={submitLoading} onClick={() => resolve()}>
            {I18n.t("papp.common.cancel")}
          </Button>
          <Button
            as="a"
            primary
            floated="right"
            disabled={!order.customer_email || submitLoading}
            onClick={this.handleSubmit.bind(this, { notifyCustomer: newStatus != "finished" ? true : false }, true)}
            content={I18n.t(
              `papp.orders.ChangeOrderStatusPrompt.${
                newStatus != "finished" ? "save_and_notify_customer" : "save_and_send_opinion_request"
              }`
            )}
          />
          <Button
            as="a"
            primary
            floated="right"
            disabled={submitLoading}
            onClick={this.handleSubmit.bind(this, { notifyCustomer: false }, false)}
            content={I18n.t("papp.common.save")}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default function openChangeOrderStatusPrompt(props) {
  return st.createModal(ChangeOrderStatusPrompt, props);
}



// WEBPACK FOOTER //
// ./src/modules/orders/ShowOrderView/ChangeOrderStatusPrompt.jsx